<template>
  <div class="course-goods-list">
    <div class="goods-wrap">
      <div class="title-bar">
        <a-row type="flex" justify="space-between">
          <a-col :span="4">
            <slot name="title"> </slot>
          </a-col>
        </a-row>
      </div>
      <div class="goods-list">
        <a-empty
          :description="'暂无数据'"
          v-if="!spinning && goodsList.length == 0"
        />
        <a-spin :spinning="spinning">
          <a-row type="flex" justify="start" v-if="goodsList.length > 0">
            <a-col :span="span" v-for="(item, index) in goodsList" :key="index">
              <PhotoCard >
                <img
                    @click="toGoodsDetail(item)"
                    slot="img"
                    :src="item.activityCover_url"
                    alt=""
                    style="width: 100%; max-height: 420px; border-radius: 10px"
                  />
                <div slot="content" @click="toGoodsDetail(item)">
                  <h3 class="title">{{ item.activityName }}</h3>
                  <span class="post">{{ item.activityDesc }}</span>
                </div>
                <!-- <div slot="icon">
                  <li>
                    <a-icon type="qrcode"></a-icon>
                  </li>
                </div> -->
              </PhotoCard>
            </a-col>
          </a-row>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityList } from "@/api/goods";
import PhotoCard from "@/components/common/PhotoCard";
export default {
  name: "ActivityGoodsList",
  components: {
    PhotoCard: PhotoCard,
  },
  props: {
    span: {
      type: Number,
      default: 6,
    },
    type: {
      //活动类型
      type: Number,
      default: null,
    },
    status: {
      //活动状态：1正常 2推荐
      type: Number,
      default: null,
    },
    limit: {
      //数量
      type: Number,
      default: 99,
    },
  },
  data() {
    return {
      courseTypes: [],
      goodsList: [],
      spinning: true,
    };
  },
  created() {
    this.getActivityList();
  },
  methods: {
    getActivityList() {
      let userId = this.$store.getters.userInfo && this.$store.getters.userInfo.id || ''
      getActivityList(userId, this.type, null, null, this.status, this.limit).then(
        (res) => {
          this.goodsList = res.result;
          this.spinning = false;
        }
      );
    },
    toGoodsDetail(item) {
      this.$emit("select", item)
    },
  },
};
</script>

<style lang="less">
.course-goods-list {
  min-height: 200px;
  .title-bar {
    text-align: left;
    i {
      font-size: 25px;
    }
    .title {
      font-size: 20px;
      font-weight: 700;
      color: white;
      margin-left: 10px;
      display: inline;
      text-shadow: 0px 0px 2px black;
    }
  }
  .goods-list {
    .photo-card {
      margin: 20px 30px;
      cursor: pointer;
      box-shadow: 0px 9px 9px 0px #00000038;
    }
  }
}
</style>